// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

/////////////////////////////////////////
// ENDPOINT WEB SOCKET SCHEMA
/////////////////////////////////////////

export const EndpointWebSocketSchema = z.object({
  subprotocol: z.string().nullable(),
  outboundMessageSchema: z.string().nullable(),
  inboundMessageSchema: z.string().nullable(),
})

export type EndpointWebSocket = z.infer<typeof EndpointWebSocketSchema>

export default EndpointWebSocketSchema;
